{
  "SLA": {
    "HEADER": "Ugovori o razini usluge",
    "ADD_ACTION": "Dodaj SLA",
    "ADD_ACTION_LONG": "Izradi novo SLA pravilo",
    "DESCRIPTION": "Ugovori o razini usluge (SLA) jasno definiraju očekivanja između vašeg tima i kupaca. Postavljaju standarde za vrijeme odgovora i rješavanja, osiguravaju odgovornost te dosljedno i kvalitetno iskustvo.",
    "LEARN_MORE": "Saznajte više o SLA-u",
    "LOADING": "Dohvaćanje SLA-ova",
    "PAYWALL": {
      "TITLE": "Nadogradite za izradu SLA-ova",
      "AVAILABLE_ON": "Značajka SLA dostupna je samo u paketima Business i Enterprise.",
      "UPGRADE_PROMPT": "Nadogradite paket za pristup naprednim značajkama kao što su upravljanje timovima, automatizacije, prilagođeni atributi i drugo.",
      "UPGRADE_NOW": "Nadogradi sada",
      "CANCEL_ANYTIME": "Paket možete promijeniti ili otkazati u bilo kojem trenutku"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Značajka SLA dostupna je samo u plaćenim paketima.",
      "UPGRADE_PROMPT": "Nadogradite na plaćeni paket za pristup naprednim značajkama kao što su zapisnici revizije, kapacitet agenata i drugo.",
      "ASK_ADMIN": "Za nadogradnju se obratite svom administratoru."
    },
    "LIST": {
      "404": "U ovom računu nema dostupnih SLA-ova.",
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "Problemi enterprise kupaca koji zahtijevaju hitnu pozornost.",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "Problemi enterprise kupaca koje treba brzo potvrditi."
      },
      "BUSINESS_HOURS_ON": "Radno vrijeme uključeno",
      "BUSINESS_HOURS_OFF": "Radno vrijeme isključeno",
      "RESPONSE_TYPES": {
        "FRT": "Prag vremena prvog odgovora",
        "NRT": "Prag vremena sljedećeg odgovora",
        "RT": "Prag vremena rješavanja",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Naziv SLA-a",
        "PLACEHOLDER": "Naziv SLA-a",
        "REQUIRED_ERROR": "Naziv SLA-a je obavezan",
        "MINIMUM_LENGTH_ERROR": "Potrebna su najmanje 2 znaka",
        "VALID_ERROR": "Dopuštena su samo slova, brojke, crtica i podvlaka"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "SLA za premium kupce"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Vrijeme prvog odgovora",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Vrijeme sljedećeg odgovora",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Vrijeme rješavanja",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Radno vrijeme",
        "PLACEHOLDER": "Samo tijekom radnog vremena"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "Prag mora biti broj veći od nule"
      },
      "EDIT": "Uredi",
      "CREATE": "Izradi",
      "DELETE": "Izbriši",
      "CANCEL": "Odustani"
    },
    "ADD": {
      "TITLE": "Dodaj SLA",
      "DESC": "Obećanja za izvrsnu uslugu!",
      "API": {
        "SUCCESS_MESSAGE": "SLA je uspješno dodan",
        "ERROR_MESSAGE": "Došlo je do pogreške. Pokušajte ponovno."
      }
    },
    "DELETE": {
      "TITLE": "Izbriši SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA je uspješno izbrisan",
        "ERROR_MESSAGE": "Došlo je do pogreške. Pokušajte ponovno."
      },
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "YES": "Da, izbriši",
        "NO": "Ne, zadrži"
      }
    },
    "EVENTS": {
      "TITLE": "SLA prekoračenja",
      "FRT": "Vrijeme prvog odgovora",
      "NRT": "Vrijeme sljedećeg odgovora",
      "RT": "Vrijeme rješavanja",
      "SHOW_MORE": "Još {count}",
      "HIDE": "Sakrij retke ({count})"
    }
  }
}
